import { arrow, autoUpdate, computePosition, flip, offset } from '@floating-ui/dom'

const Tooltip = {
  mounted() {
    const tooltip = this.tooltip(this.el)
    const tooltipArrow = tooltip.querySelector('[data-tooltip-arrow]')
    const tooltipArrowOffset = tooltipArrow ? Math.sqrt(2 * tooltipArrow.offsetWidth ** 2) / 2 : 0
    const initialPlacement = this.el.getAttribute('data-tooltip-placement') || 'right'

    this.cleanup = autoUpdate(this.el, tooltip, () => {
      computePosition(this.el, tooltip, {
        placement: initialPlacement,
        middleware: [
          offset(({ placement }) => {
            if (placement === 'left' || placement === 'right') {
              return tooltipArrowOffset - 12
            }

            return tooltipArrowOffset
          }),
          flip(),
          tooltipArrow && arrow({ element: tooltipArrow }),
        ],
      }).then(({ x, y, placement: updatedPlacement, middlewareData }) => {
        if (middlewareData.arrow) {
          const { x, y } = middlewareData.arrow

          Object.assign(tooltipArrow.style, {
            left: updatedPlacement === 'right' ? '-5px' : `${x}px`,
            right: updatedPlacement === 'right' ? '0' : '-5px',
            top: (updatedPlacement === 'top' || updatedPlacement === 'bottom') ? `${y}px` : '',
          });
        }

        Object.assign(tooltip.style, { left: `${x}px`, top: `${y}px` })
      })
    })
  },

  tooltip(element) {
    const target = this.el.getAttribute('data-tooltip-target') && document.getElementById(this.el.getAttribute('data-tooltip-target'))

    if (target) {
      return target
    }

    return element.querySelector('[data-tooltip]')
  },

  destroyed() {
    this.cleanup()
  },
}

export default Tooltip
